import { Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Logo from '@/icons/Logo';

interface PremiumAssessmentHeaderProps {
  assessmentTitle: string;
  userEmail: string;
  onGoHome: () => void;
}

export default function PremiumAssessmentHeader({ assessmentTitle, userEmail, onGoHome }: PremiumAssessmentHeaderProps) {
  return (
    <header className="border-b border-border/50 bg-card/80 backdrop-blur-sm sticky top-0 z-20">
      <div className="w-full px-4 md:px-6 py-3 flex items-center justify-between">
        {/* Left: Logo */}
        <div className="flex items-center gap-3 shrink-0">
          <Logo className="h-8 w-8" />
          <span className="font-semibold text-foreground hidden sm:inline">{assessmentTitle}</span>
        </div>

        {/* Right: Email + Home */}
        <div className="flex items-center gap-3">
          <span className="text-sm text-muted-foreground hidden md:inline">{userEmail}</span>
          <Button variant="ghost" size="icon" onClick={onGoHome} title="Back to Home">
            <Home className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
